// Base Vendors Bundle - Step 1 of 4-step plan
// This bundle replaces the CDN links for core libraries

// ============= CSS IMPORTS =============
// Bootstrap 5.3.2 CSS
import 'bootstrap/dist/css/bootstrap.min.css';

// FontAwesome 6.4.0 CSS  
import '@fortawesome/fontawesome-free/css/all.min.css';

// ============= JS IMPORTS =============
// jQuery 3.7.1 - Import and make globally available
import $ from 'jquery';

// Bootstrap 5.3.2 JS (full bundle with Popper.js included)
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

// ============= GLOBAL EXPORTS =============
// Make jQuery available globally for all other scripts
if (typeof window !== 'undefined') {
    window.$ = $;
    window.jQuery = $;
    
    // Ensure jQuery is available immediately
    console.log('✅ jQuery exposed globally:', typeof window.jQuery, window.jQuery.fn.jquery);
}

// ============= LOG SUCCESSFUL LOAD =============
console.log('✅ Base Vendors Bundle loaded successfully');
console.log('- Bootstrap CSS: included');
console.log('- FontAwesome CSS: included'); 
console.log('- jQuery JS:', $.fn.jquery);
console.log('- Bootstrap JS: included (with Popper.js)');
console.log('- Modernizr JS: ELIMINATED - confirmed unnecessary legacy code');
